import getCanAddMoreSuggestionPills from './getCanAddMoreSuggestionPills';
import CategorySuggestionMenuItem from '../components/CategorySuggestionMenuItem';
import KeywordSuggestionMenuItem from '../components/KeywordSuggestionMenuItem';
import MessageSuggestionMenuItem from '../components/MessageSuggestionMenuItem';
import FileSuggestionMenuItem from '../components/FileSuggestionMenuItem';
import PeopleSuggestionMenuItem from '../components/PeopleSuggestionMenuItem';
import { getStore } from '../store/store';
import { trace } from 'owa-trace';
import * as React from 'react';
import { SuggestionKind, } from 'owa-search-service';
var styles = require('../components/SuggestionsContextMenu.scss');
export default function getSuggestionMenuItemsSelector(suggestionSet) {
    /**
     * Cache existing items (if new suggestions are still in progress) to be
     * returned if new suggestions aren't ready to be displayed.
     */
    var items = [];
    /**
     * Tracks if horizontal line break separating message suggestions
     * from rest of suggestions has already been added to items.
     */
    var isMessageSuggestionDividerAdded = false;
    /**
     * Only show suggestions that'll render as pills if we can add more
     * to the search box.
     */
    var shouldShowPillSuggestions = getCanAddMoreSuggestionPills();
    suggestionSet.Suggestions.map(function (suggestion, index) {
        switch (suggestion.kind) {
            case SuggestionKind.People:
                if (shouldShowPillSuggestions) {
                    items.push(createPeopleSuggestionItem(suggestion, index));
                }
                break;
            case SuggestionKind.Keywords:
                items.push(createKeywordSuggestionItem(suggestion, index));
                break;
            case SuggestionKind.Message:
                /**
                 * Checks if horizontal line break separating message
                 * suggestions from rest of suggestions has already been
                 * added. Adds if not.
                 */
                if (!isMessageSuggestionDividerAdded) {
                    items.push({
                        key: 'search_messageSuggestion_divider',
                        name: '-',
                    });
                    // Tracks that horizontal line break was added to items.
                    isMessageSuggestionDividerAdded = true;
                }
                items.push(createMessageSuggestionItem(suggestion, index));
                break;
            case SuggestionKind.Category:
                if (shouldShowPillSuggestions) {
                    items.push(createCategorySuggestionItem(suggestion, index));
                }
                break;
            case SuggestionKind.Files:
                items.push(createFileSuggestionItem(suggestion, index));
                break;
            default:
                trace.error('Attempted to render an unsupported suggestion type.');
        }
    });
    return items;
}
function createKeywordSuggestionItem(suggestion, index) {
    return {
        className: getStore().selectedSuggestionIndex == index && styles.suggestionSelected,
        key: suggestion.DisplayText,
        name: suggestion.DisplayText,
        onRender: function () { return React.createElement(KeywordSuggestionMenuItem, { suggestion: suggestion }); },
    };
}
function createPeopleSuggestionItem(suggestion, index) {
    return {
        key: suggestion.EmailAddresses[0],
        name: suggestion.DisplayName,
        className: getStore().selectedSuggestionIndex == index && styles.suggestionSelected,
        onRender: function () { return React.createElement(PeopleSuggestionMenuItem, { suggestion: suggestion }); },
    };
}
function createMessageSuggestionItem(suggestion, index) {
    return {
        key: suggestion.Subject,
        name: suggestion.Subject,
        className: getStore().selectedSuggestionIndex == index && styles.suggestionSelected,
        onRender: function () { return React.createElement(MessageSuggestionMenuItem, { suggestion: suggestion }); },
    };
}
function createFileSuggestionItem(suggestion, index) {
    return {
        key: suggestion.Name,
        name: suggestion.Name,
        className: getStore().selectedSuggestionIndex == index && styles.suggestionSelected,
        onRender: function () { return React.createElement(FileSuggestionMenuItem, { suggestion: suggestion }); },
    };
}
function createCategorySuggestionItem(suggestion, index) {
    return {
        key: suggestion.ReferenceId,
        name: suggestion.Name,
        className: getStore().selectedSuggestionIndex == index && styles.suggestionSelected,
        onRender: function () { return React.createElement(CategorySuggestionMenuItem, { suggestion: suggestion }); },
    };
}
//# sourceMappingURL=getSuggestionMenuItemsSelector.js.map